"use strict";
exports.__esModule = true;
exports.InternalServerError = exports.OK = void 0;
// export const Continue = 100;
// export const Switchingprotocols = 101;
exports.OK = 200;
// export const Created = 201;
// export const Accepted = 202;
// export const NonAuthoritativeInformation = 203;
// export const NoContent = 204;
// export const ResetContent = 205;
// export const PartialContent = 206;
// export const MultipleChoices = 300;
// export const MovedPermanently = 301;
// export const Found = 302;
// export const SeeOther = 303;
// export const NotModified = 304;
// export const UseProxy = 305;
// export const TemporaryRedirect = 307;
// export const BadRequest = 400;
// export const Unauthorized = 401;
// export const PaymentRequired = 402;
// export const Forbidden = 403;
// export const NotFound = 404;
// export const MethodNotAllowed = 405;
// export const NotAcceptable = 406;
// export const ProxyAuthenticationRequired = 407;
// export const RequestTimeout = 408;
// export const Conflict = 409;
// export const Gone = 410;
// export const LengthRequired = 411;
// export const PreconditionFailed = 412;
// export const RequestEntityTooLarge = 413;
// export const RequestURITooLong = 414;
// export const UnsupportedMediaType = 415;
// export const RequestedRangeNotSuitable = 416;
// export const ExpectationFailed = 417;
exports.InternalServerError = 500;
// export const NotImplemented = 501;
// export const BadGateway = 502;
// export const ServiceUnavailable = 503;
// export const GatewayTimeout = 504;
// export const HTTPVersionNotSupported = 505;
//# sourceMappingURL=status.js.map